import { render, staticRenderFns } from "./TrustedSourceModal.vue?vue&type=template&id=0a1b2893&scoped=true&"
import script from "./TrustedSourceModal.vue?vue&type=script&lang=js&"
export * from "./TrustedSourceModal.vue?vue&type=script&lang=js&"
import style0 from "./TrustedSourceModal.vue?vue&type=style&index=0&id=0a1b2893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1b2893",
  null
  
)

export default component.exports